import { SectionHeader } from "./SectionHeader";
import type { Theme } from "./theme";

const PILLARS = [
  {
    n: "01",
    t: "A clear role blueprint",
    s: "Hiring outcomes improve when there is a precise definition of what success looks like. A strong blueprint defines the capabilities, outcomes, and context of the role — ensuring everyone is aligned from the start.",
  },
  {
    n: "02",
    t: "Consistent candidate assessment",
    s: "Hiring decisions improve when candidates are evaluated against the same criteria. Structured, evidence-based assessment allows stakeholders to evaluate candidates clearly and make decisions with confidence.",
  },
];

export function Shift({ theme }: { theme: Theme }) {
  return (
    <section
      style={{ padding: "clamp(72px, 12vw, 120px) 0", borderTop: `1px solid ${theme.border}` }}
    >
      <SectionHeader theme={theme} title="What drives better hiring decisions." />
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 clamp(20px, 5vw, 40px)" }}>
        <p
          style={{
            fontSize: 19,
            color: theme.fgMute,
            maxWidth: 720,
            lineHeight: 1.55,
            marginBottom: 56,
          }}
        >
          Better hiring outcomes do not come from more activity. They come from clarity and
          consistency.
        </p>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 24,
          }}
        >
          {PILLARS.map((x) => (
            <div
              key={x.n}
              style={{
                padding: 32,
                background: theme.bg,
                border: `1px solid ${theme.border}`,
                borderRadius: theme.radius,
                minHeight: 220,
                display: "flex",
                flexDirection: "column",
                gap: 16,
              }}
            >
              <div
                style={{
                  fontFamily: theme.mono,
                  fontSize: 12,
                  color: theme.fgMute,
                  letterSpacing: 1,
                }}
              >
                {x.n}
              </div>
              <div
                style={{
                  fontSize: 22,
                  fontWeight: 600,
                  color: theme.fg,
                  letterSpacing: -0.3,
                  lineHeight: 1.25,
                }}
              >
                {x.t}
              </div>
              <div
                style={{
                  fontSize: 15,
                  color: theme.fgMute,
                  lineHeight: 1.6,
                }}
              >
                {x.s}
              </div>
            </div>
          ))}
        </div>
        <p
          style={{
            fontSize: 19,
            fontWeight: 500,
            color: theme.fg,
            letterSpacing: -0.3,
            maxWidth: 720,
            lineHeight: 1.5,
            marginTop: 56,
            paddingTop: 32,
            borderTop: `1px solid ${theme.border}`,
          }}
        >
          <span style={{ color: theme.accentFg }}>Clarity</span>
          <span style={{ color: theme.fgMute }}> + </span>
          <span style={{ color: theme.accentFg }}>Consistency</span>
          <span style={{ color: theme.fgMute }}> = </span>
          <span>Decision confidence.</span>
        </p>
      </div>
    </section>
  );
}
